import { PulseBaseProvider } from '../../base-classes';

const _alertsUri = '/data/alerts/v2/alerts';
const _notificationsUri = 'api/push/v1/notifications';
const _notificationsStatusUri = 'api/push/v1/notifications/status';
const _alertsCacheKey = 'alerts';
const __notificationsCacheKey = 'alertsNotifications';
const _notificationsStatusCacheKey = 'notificationsStatus';

export class AlertsProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_alertsCacheKey] = this.alertsSyncer.bind(this);
        this.storage.sync[__notificationsCacheKey] = this.notificationsSyncer.bind(this);
        this.storage.sync[_notificationsStatusCacheKey] = this.notificationsStatusSyncer.bind(this);
    }

    async alertsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            locationtype: 'latitudelongitude',
            location: `${syncParams.latitude},${syncParams.longitude}`,
            verbose: syncParams.verbose
        };

        return await super.syncData(syncParams.key, id, queryParams, _alertsUri, resolve, reject, null, syncParams.pulseApi);
    }

    async getAlerts(latitude, longitude, stdParameters, verbose, refresh = false) {
        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            refresh
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_alertsCacheKey, id);
        }
        return await super.loadFromStorage(_alertsCacheKey, id, syncParams);
    }


    // this calls the newer Notifications API
    async notificationsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            emLocationId: syncParams.emLocationId,
            latitude: syncParams.latitude,
            longitude: syncParams.longitude
        };

        return await super.syncData(syncParams.key, id, queryParams, _notificationsUri, resolve, reject, null, syncParams.pulseApi);
    }

    async getNotifications(latitude, longitude, stdParameters, verbose, refresh = false, emLocationId) {

        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            refresh,
            emLocationId
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(__notificationsCacheKey, id);
        }
        return await super.loadFromStorage(__notificationsCacheKey, id, syncParams);
    }

    // this calls the notifications status endpoint for the alerts triangle icon
    async notificationsStatusSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            emLocationId: syncParams.emLocationId,
            latitude: syncParams.latitude,
            longitude: syncParams.longitude
        };

        return await super.syncData(syncParams.key, id, queryParams, _notificationsStatusUri, resolve, reject, null, syncParams.pulseApi);
    }

    async getNotificationsStatusProvider(latitude, longitude, stdParameters, verbose, refresh = false, emLocationId) {

        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            refresh,
            emLocationId
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_notificationsStatusCacheKey, id);
        }
        return await super.loadFromStorage(_notificationsStatusCacheKey, id, syncParams);
    }
}

